// Add your JS customizations here

// fix menu on desktop
jQuery(function($){

    $(document).ready(function(){
        bp_menu()
        filterlink()
        filterSwitch()
    })
    $(window).resize(function(){
        bp_menu()
    });

    function bp_menu() {
        $('.navbar-toggler').on('click', function(){
            $('body').toggleClass('menu-open')
        })
        // $(window).scroll(function(){
        //     let sp = $(window).scrollTop()
        //     console.log(sp)
        //     if (sp >= 128) {
        //         $('.navbar-toggler').addClass('fixed_mobMenu')
        //     } else {
        //         $('.navbar-toggler').removeClass('fixed_mobMenu')
        //     }
        // })

        let isMobile = window.matchMedia("only screen and (max-width: 767px)").matches;
        if (!isMobile) {
            $('a.dropdown-toggle').removeAttr('data-toggle data-bs-toggle')
            // $atts['data-toggle']    = 'dropdown';
            // $atts['data-bs-toggle'] = 'dropdown';
            const menu = $('#main-menu')
            let cl = 0
            $('a.dropdown-toggle').on('mouseenter', function() {
                const dm = $(this)
                const subm = $(this).siblings('.dropdown-menu')
                dm.attr('aria-expanded', true).addClass('show')
                .on('mouseleave', function(){
                    setTimeout(function(){
                        if (cl == 0){
                            dm.attr('aria-expanded', false).removeClass('show')
                            subm.removeAttr('data-bs-popper').removeClass('show')
                        }
                    }, 10)
                })
                subm.addClass('show').attr('data-bs-popper', 'static')
                .on('mouseenter', function(){
                    cl = 1
                })
                .on('mouseleave', function(){
                    dm.attr('aria-expanded', false).removeClass('show')
                    subm.removeAttr('data-bs-popper').removeClass('show')
                    cl = 0
                })
            });
        } else {
            $('a.dropdown-toggle').attr({'data-toggle': 'dropdown', 'data-bs-toggle': 'dropdown'})
            .off('mouseenter mouseleave')
            .siblings('.dropdown-menu').off('mouseenter mouseleave')
        }
    }

    function filterlink(){
        const currentpage = window.location.href
        $('.cl_link').each(function(){
            let link = $(this).attr('href')
            if( currentpage == link ){
                $(this).addClass('_active')
            }
        })
    }

    function filterSwitch() {
        const filter = $('.bp_resp-filter');
        filter.on('click', function(){
            this.classList.toggle("_active");
        })
    }



})


